import EmailPulseSummaryCards from '../email-pulse-summary-cards/email-pulse-summary-cards.component';
import { messagesSummaryCardsConfig } from './messages.config';

/**
 * Messages tab summary cards component.
 * Wrapper around the generic EmailPulseSummaryCards with Messages-specific configuration.
 */
const MessagesSummaryCards = () => {
  return <EmailPulseSummaryCards config={messagesSummaryCardsConfig} />;
};

export default MessagesSummaryCards;
